<template>
  <div>
    <div class="my-school-preference">
      <div class="preference-title-row">
        <!-- TITLE -->
        <div class="preference-title">School Settings</div>
      </div>

      <!-- TOP SECTION -->
      <div class="top-section">
        <!-- SCHOOL CARD -->
        <div class="school-card">
          <div class="type-title color_grey_dark font-weight-bold">
            Curriculum
          </div>
          <div class="type-row d-flex justify-content-start align-items-center">
            <div class="type-value brand_navy" v-if="active_curriculum">
              {{
                active_curriculum === "Nigeria" ? "Nigerian" : active_curriculum
              }}
              Curriculum
            </div>
            <div class="type-value border_grey_dark" v-else>No Curriculum</div>
            <router-link
              to
              @click.native="toggleCurriculumListModal"
              class="type-btn brand_accent font-weight-bold text-uppercase"
              >Update</router-link
            >
          </div>
        </div>

        <div class="school-card">
          <div class="type-title color_grey_dark font-weight-bold">
            School Type
          </div>
          <div class="type-row d-flex justify-content-start align-items-center">
            <div
              class="type-value brand_navy text-capitalize"
              v-if="school_type_data"
            >
              {{ school_type_title }}
            </div>
            <div class="type-value border_grey_dark text-capitalize" v-else>
              No School type
            </div>
            <router-link
              to
              @click.native="toggleSchoolType"
              class="type-btn brand_accent font-weight-bold text-uppercase"
              >Update</router-link
            >
          </div>
        </div>
      </div>

      <!-- BOTTOM SECTION -->
      <div class="bottom-section">
        <AcademicCalendar></AcademicCalendar>
      </div>

      <!-- MODAL COMPONENTS -->
      <CurriculumListModal
        v-if="curriculum_list_modal"
        :active_curriculum="active_curriculum"
        :curriculum_list="curriculum_list"
        @closeTriggered="toggleCurriculumListModal"
        @toggleRequestModal="toggleCurriculumRequestModal"
        @showAlertCard="popUpAlert($event)"
      ></CurriculumListModal>

      <CurriculumRequestModal
        v-if="curriculum_request_modal"
        @closeTriggered="toggleCurriculumRequestModal"
        @showAlertCard="popUpAlert($event)"
      ></CurriculumRequestModal>

      <SchoolTypeModal
        v-if="school_type_modal"
        :school_type_data="school_type_data"
        :naming_format_data="naming_format_data"
        @closeTriggered="toggleSchoolType"
        @showAlertCard="popUpAlert($event)"
      ></SchoolTypeModal>

      <ResponseDialog
        v-if="response_dialog"
        :alert_msg="alert_card_msg"
        :alert_type="alert_card_type"
        @closeAlert="toggleResponseDialog"
      ></ResponseDialog>
      <!-- MODAL COMPONENTS -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CurriculumPreference",

  components: {
    AcademicCalendar: () =>
      import(
        /* webpackChunkName: "AcademicCalendar" */ "@/components/globalComps/SettingsComps/PreferenceComps/AcademicCalendar"
      ),
    CurriculumListModal: () =>
      import(
        /* webpackChunkName: "CurriculumListModal" */ "@/components/modalComps/settingsModals/CurriculumListModal"
      ),
    CurriculumRequestModal: () =>
      import(
        /* webpackChunkName: "CurriculumRequestModal" */ "@/components/modalComps/settingsModals/CurriculumRequestModal"
      ),
    SchoolTypeModal: () =>
      import(
        /* webpackChunkName: "SchoolTypeModal" */ "@/components/modalComps/settingsModals/SchoolTypeModal"
      ),
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  data() {
    return {
      curriculum_list_modal: false,
      curriculum_request_modal: false,
      school_type_modal: false,
      curriculum_list: [],
      active_curriculum: null,
      curriculum_title: "",

      school_type_data: "",
      naming_format_data: "",
      school_type_title: "",

      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,
    };
  },

  mounted() {
    this.fetchCurriculums();
    this.fetchSchoolProfile();
  },

  methods: {
    ...mapActions(["getCurriculum", "getSchoolProfile"]),

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    popUpAlert($event) {
      this.alert_card_msg = $event.msg;
      this.alert_card_type = $event.type;
      this.toggleResponseDialog();
    },

    fetchSchoolProfile() {
      this.getSchoolProfile()
        .then((response) => {
          // console.log("SCHOOL PROFILE", response);

          response.code !== 200 ? this.fetchSchoolProfile() : "";
          this.school_type_data = response.data.school_type;

          if (response.data.school_type === "all")
            this.school_type_title = "Primary and Secondary";
          else this.school_type_title = response.data.school_type;

          this.school_type_data = response.data.school_type;
          this.naming_format_data = response.data.naming_format;
        })
        .catch((err) => console.log(err));
    },

    fetchCurriculums() {
      this.getCurriculum()
        .then((response) => {
          this.active_curriculum = "";
          this.curriculum_list = [];
          this.curriculum_list = [...response.data];

          // GET ACTIVE CURRICULUM
          let curriculums = this.curriculum_list;
          curriculums.map((curriculum) => {
            if (curriculum.active === "1")
              this.active_curriculum = curriculum.title;
          });
        })
        .catch((err) => console.log(err));
    },

    toggleCurriculumListModal() {
      this.curriculum_list_modal = !this.curriculum_list_modal;
      this.fetchCurriculums();
    },

    toggleCurriculumRequestModal() {
      this.curriculum_list_modal = false;
      this.curriculum_request_modal = !this.curriculum_request_modal;
    },

    toggleSchoolType() {
      this.school_type_modal = !this.school_type_modal;
      this.fetchSchoolProfile();
    },
  },
};
</script>

<style lang="scss">
.my-school-preference {
  .preference-title {
    margin-bottom: 15px;

    @include breakpoint_max(sm) {
      margin-bottom: 5px;
      font-size: 11.5px !important;
    }
  }

  .top-section {
    padding-bottom: 10px;
    border-bottom: 1px solid $border_grey;

    .school-card {
      margin-bottom: 30px;

      .type-title {
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 5px;

        @include breakpoint_max(sm) {
          font-size: 12.5px;
        }
      }

      .type-value {
        font-size: 15px;
        line-height: 25px;
        margin-right: 40px;

        @include breakpoint_max(sm) {
          font-size: 13.25px;
          margin-right: 30px;
        }
      }

      .type-btn {
        font-size: 14px;
        line-height: 19px;

        @include breakpoint_max(sm) {
          font-size: 11.5px;
          font-weight: 600 !important;
        }
      }
    }
  }
}
</style>
